import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import UsingStylesUtils from './UsingStylesUtils';
import ClientProvider from './client';
export default createDemo(import.meta.url, UsingStylesUtils, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/palette/demos/using-styles-utils/UsingStylesUtils.tsx",
    "fileName": "UsingStylesUtils.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import {\n  createTheme,\n  ThemeProvider,\n  alpha,\n  getContrastRatio,\n} from '@mui/material/styles';\nimport Button from '@mui/material/Button';\nimport Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Typography from '@mui/material/Typography';\n\n// Augment the palette to include a violet color\ndeclare module '@mui/material/styles' {\n  interface Palette {\n    violet: Palette['primary'];\n  }\n\n  interface PaletteOptions {\n    violet?: PaletteOptions['primary'];\n  }\n}\n\n// Update the Button's color options to include a violet option\ndeclare module '@mui/material/Button' {\n  interface ButtonPropsColorOverrides {\n    violet: true;\n  }\n}\n\nconst violetBase = '#7F00FF';\nconst violetMain = alpha(violetBase, 0.7);\n\nconst theme = createTheme({\n  palette: {\n    violet: {\n      main: violetMain,\n      light: alpha(violetBase, 0.5),\n      dark: alpha(violetBase, 0.9),\n      contrastText: getContrastRatio(violetMain, '#fff') > 4.5 ? '#fff' : '#111',\n    },\n  },\n});\n\nexport default function UsingStylesUtils() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={theme}>\n      <Stack sx={{ gap: 2, alignItems: 'center' }}>\n        <Button variant=\"contained\" color=\"violet\">\n          Violet\n        </Button>\n        <Stack direction=\"row\" sx={{ gap: 1 }}>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">light</Typography>\n            <Box sx={{ bgcolor: 'violet.light', width: 40, height: 20 }} />\n          </Stack>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">main</Typography>\n            <Box sx={{ bgcolor: 'violet.main', width: 40, height: 20 }} />\n          </Stack>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">dark</Typography>\n            <Box sx={{ bgcolor: 'violet.dark', width: 40, height: 20 }} />\n          </Stack>\n        </Stack>\n      </Stack>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 68,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import {\n  createTheme,\n  ThemeProvider,\n  alpha,\n  getContrastRatio,\n} from '@mui/material/styles';\nimport Button from '@mui/material/Button';\nimport Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Typography from '@mui/material/Typography';\n\n// Augment the palette to include a violet color\ndeclare module '@mui/material/styles' {\n  interface Palette {\n    violet: Palette['primary'];\n  }\n\n  interface PaletteOptions {\n    violet?: PaletteOptions['primary'];\n  }\n}\n\n// Update the Button's color options to include a violet option\ndeclare module '@mui/material/Button' {\n  interface ButtonPropsColorOverrides {\n    violet: true;\n  }\n}\n\nconst violetBase = '#7F00FF';\nconst violetMain = alpha(violetBase, 0.7);\n\nconst theme = createTheme({\n  palette: {\n    violet: {\n      main: violetMain,\n      light: alpha(violetBase, 0.5),\n      dark: alpha(violetBase, 0.9),\n      contrastText: getContrastRatio(violetMain, '#fff') > 4.5 ? '#fff' : '#111',\n    },\n  },\n});\n\nexport default function UsingStylesUtils() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <ThemeProvider theme={theme}>\n      <Stack sx={{ gap: 2, alignItems: 'center' }}>\n        <Button variant=\"contained\" color=\"violet\">\n          Violet\n        </Button>\n        <Stack direction=\"row\" sx={{ gap: 1 }}>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">light</Typography>\n            <Box sx={{ bgcolor: 'violet.light', width: 40, height: 20 }} />\n          </Stack>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">main</Typography>\n            <Box sx={{ bgcolor: 'violet.main', width: 40, height: 20 }} />\n          </Stack>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">dark</Typography>\n            <Box sx={{ bgcolor: 'violet.dark', width: 40, height: 20 }} />\n          </Stack>\n        </Stack>\n      </Stack>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 68,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Button",
      "@mui/material/Box",
      "@mui/material/Stack",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
